const DEFAULT_FORM_DATA = {
  broker: {
    email: "",
    feeAmount: undefined,
    brokerFeeAddedToLoan: undefined,
    lenderFeeAddedToLoan: undefined,
    firmName: "",
    name: "",
    phoneNumber: "",
  },
};

export default DEFAULT_FORM_DATA;
